type GetProjectProps = {
  baseUrl: string;
  token: string;
  repoName: string;
  repoLocation: string;
};

export const getProject = async ({
  baseUrl,
  token,
  repoLocation,
  repoName,
}: GetProjectProps) => {
  // Get Project ID
  const projectUrl = new URL(`${baseUrl}/infinity-api/project`);
  projectUrl.search = new URLSearchParams({
    namespace: repoLocation.split(
      'https://gitlab.transics-cicd.aws.zf.com/',
    )[1],
    name: repoName,
  }).toString();

  const response = await fetch(projectUrl.toString(), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    if (response.status !== 404) {
      throw new Error(`Infinity gitlab api error ${response.status}`, {
        cause: response.statusText,
      });
    }
  }

  const { project_id: projectId } = (await response.json()) as {
    project_id: string;
  };
  return { projectId };
};
